import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import dailyAttendance from "../../../containers/modules/hr/daily-attendance";

export default function DailyAttendanceRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="daily-attendance"
      index
      element={
        <AccessControl
          name={"Daily Attendance List"}
          auth={authUser}
          component={dailyAttendance}
        />
      }
    ></Route>
  );
}
